<template>
  <div>
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <h1 class="h2 px-4">Overzicht</h1>
    </div>

    <vue-cal
      :events="events"
      :time-step="15"
      :snap-to-time="15"
      :time-from="5 * 60"
      :disable-views="['years', 'year', 'month']"
      :hide-weekdays="[7]"
      :editable-events="{ title: false, drag: true, resize: false, delete: false, create: false }"
      @ready="loadEvents($event)"
      :on-event-click="editEvent"
      @dragstart="onEventDragStart($event, item)"
      locale="nl"
    >
    </vue-cal>

    <!-- Modal -->
    <modal name="overzichtModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Bestelling</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <ul v-if="modalType !== 'levering-product'" class="nav nav-tabs" role="tablist">
              <li role="presentation">
                <a
                  class="nav-link active show"
                  href="#leveringTab"
                  aria-controls="leveringTab"
                  role="tab"
                  data-toggle="tab"
                  >Levering</a
                >
              </li>
              <li role="presentation">
                <a class="nav-link" href="#ophalingTab" aria-controls="ophalingTab" role="tab" data-toggle="tab"
                  >Ophaling</a
                >
              </li>
              <li role="presentation">
                <a class="nav-link" href="#fotosTab" aria-controls="fotosTab" role="tab" data-toggle="tab">Foto's</a>
              </li>
            </ul>

            <div class="tab-content">
              <div role="tabpanel" class="tab-pane active" id="leveringTab" v-if="bestelling">
                <label>Datum</label>
                <input
                  v-if="modalType !== 'levering-product'"
                  class="form-control"
                  v-model="bestelling.leveringsdatum"
                  type="text"
                />
                <input v-else class="form-control" v-model="bestelling.datum" type="text" />
                <label>Richtuur</label>
                <vue-timepicker
                  v-if="modalType !== 'levering-product'"
                  v-model="bestelling.leveringsrichtuur"
                  :minute-interval="15"
                ></vue-timepicker>
                <vue-timepicker v-else v-model="bestelling.richtuur" :minute-interval="15"></vue-timepicker>
                <hr />
                <label>Container</label>
                <select class="form-control" v-model="bestelling.container" disabled readonly>
                  <option
                    v-for="container in containers"
                    :key="container.id"
                    :value="container.id"
                    :disabled="!container.beschikbaar"
                    :selected="bestelling.container"
                  >
                    {{ container.beschrijving }}
                  </option>
                </select>
                <label>Vrachtwagen</label>
                <template v-if="modalType !== 'levering-product'">
                  <select
                    class="form-control"
                    v-model="bestelling.leveringsvrachtwagen"
                    :disabled="utype !== 'Administrator'"
                    :readonly="utype !== 'Administrator'"
                  >
                    <option
                      v-for="vrachtwagen in vrachtwagens"
                      :key="vrachtwagen.id"
                      :value="vrachtwagen.id"
                      :selected="bestelling.leveringsvrachtwagen"
                    >
                      {{ vrachtwagen.beschrijving }}
                    </option>
                  </select></template
                >
                <template v-else>
                  <select
                    class="form-control"
                    v-model="bestelling.vrachtwagen"
                    :disabled="utype !== 'Administrator'"
                    :readonly="utype !== 'Administrator'"
                  >
                    <option
                      v-for="vrachtwagen in vrachtwagens"
                      :key="vrachtwagen.id"
                      :value="vrachtwagen.id"
                      :selected="bestelling.vrachtwagen"
                    >
                      {{ vrachtwagen.beschrijving }}
                    </option>
                  </select>
                </template>
                <label>Chauffeur</label>
                <template v-if="modalType !== 'levering-product'">
                  <select
                    class="form-control"
                    v-model="bestelling.leveringschauffeur"
                    :disabled="utype !== 'Administrator'"
                    :readonly="utype !== 'Administrator'"
                  >
                    <option
                      v-for="chauffeur in chauffeurs"
                      :key="chauffeur.id"
                      :value="chauffeur.id"
                      :selected="bestelling.chauffeur"
                    >
                      {{ chauffeur.naam }}
                    </option>
                  </select>
                </template>
                <template v-if="modalType === 'levering-product'">
                  <select
                    class="form-control"
                    v-model="bestelling.chauffeur"
                    :disabled="utype !== 'Administrator'"
                    :readonly="utype !== 'Administrator'"
                  >
                    <option
                      v-for="chauffeur in chauffeurs"
                      :key="chauffeur.id"
                      :value="chauffeur.id"
                      :selected="bestelling.chauffeur"
                    >
                      {{ chauffeur.naam }}
                    </option>
                  </select>
                </template>
                <hr />
                <label>Klant</label>
                <select class="form-control" v-model="bestelling.klant" disabled readonly>
                  <option v-for="klant in klanten" :key="klant.id" :value="klant.id" :selected="bestelling.klant">
                    {{ klant.klantnaam }}
                  </option>
                </select>
                <label>Werf</label>
                <select class="form-control" v-model="bestelling.werf" disabled readonly>
                  <option v-for="werf in werven" :key="werf.id" :value="werf.id" :selected="bestelling.werf">
                    {{ werf.beschrijving }}
                  </option>
                </select>
                <template v-if="modalType !== 'levering-product'">
                  <label>Afvalproduct</label>
                  <select
                    class="form-control"
                    v-model="bestelling.afvalproduct"
                    :key="bestelling.id"
                    :selected="bestelling.afvalproduct"
                    disabled
                    readonly
                  >
                    <option value disabled>- Kies een afvalproduct -</option>
                    <option value="1">Gemengd afval</option>
                    <option value="2">Zuiver mengpuin</option>
                    <option value="3">Grond en stenen</option>
                    <option value="4">Bouw- en sloopafval</option>
                    <option value="5">Hout</option>
                    <option value="6">Groenafval</option>
                  </select></template
                >
                <template v-if="modalType === 'levering-product'">
                  <label>Product</label>
                  <select
                    class="form-control"
                    v-model="bestelling.leveringsproduct"
                    :key="bestelling.id"
                    :selected="bestelling.leveringsproduct"
                    disabled
                    readonly
                  >
                    <option v-for="product in leveringsproducten" :key="product.id" :value="product.id">{{
                      product.naam
                    }}</option>
                  </select>
                </template>
                <label>Notities</label>
                <textarea
                  class="form-control"
                  v-model="bestelling.notities_levering"
                  placeholder="Notities"
                  disabled
                  readonly
                ></textarea>

                <template v-if="modalType === 'levering-product'">
                  <hr />
                  <label>Betalingswijze</label>
                  <select
                    class="form-control"
                    v-model="bestelling.betalingswijze"
                    :selected="bestelling.betalingswijze"
                    disabled
                    readonly
                  >
                    <option value="Factuur">Factuur</option>
                    <option value="Contant">Contant</option>
                    <option value="Bancontact">Bancontact</option>
                  </select>
                  <label>Betalingsstatus</label>
                  <select class="form-control" v-model="bestelling.betalingsstatus">
                    <option value="Niet betaald">Niet betaald</option>
                    <option value="Betaald">Betaald</option>
                  </select>
                </template>
                <button
                  type="button"
                  class="btn btn-secondary float-right mt-2"
                  v-on:click="printVrachtbon(bestelling.id, 'plaatsing')"
                >
                  Print vrachtbon
                </button>
                <button type="button" class="btn btn-secondary float-right mt-2 mr-2" v-on:click="signVrachtbon()">
                  Vrachtbon tekenen
                </button>
              </div>

              <div role="tabpanel" class="tab-pane" id="ophalingTab" v-if="bestelling">
                <label>Datum</label>
                <input class="form-control" v-model="bestelling.ophalingsdatum" type="text" />
                <label>Richtuur</label>
                <vue-timepicker v-model="bestelling.ophalingsrichtuur" :minute-interval="15"></vue-timepicker>
                <hr />
                <label>Vrachtwagen</label>
                <select
                  class="form-control"
                  v-model="bestelling.ophalingsvrachtwagen"
                  :disabled="utype !== 'Administrator'"
                  :readonly="utype !== 'Administrator'"
                >
                  <option
                    v-for="vrachtwagen in vrachtwagens"
                    :key="vrachtwagen.id"
                    :value="vrachtwagen.id"
                    :selected="bestelling.vrachtwagen"
                  >
                    {{ vrachtwagen.beschrijving }}
                  </option>
                </select>
                <label>Chauffeur</label>
                <select
                  class="form-control"
                  v-model="bestelling.ophalingschauffeur"
                  :disabled="utype !== 'Administrator'"
                  :readonly="utype !== 'Administrator'"
                >
                  <option
                    v-for="chauffeur in chauffeurs"
                    :key="chauffeur.id"
                    :value="chauffeur.id"
                    :selected="bestelling.chauffeur"
                  >
                    {{ chauffeur.naam }}
                  </option>
                </select>
                <hr />
                <label>Gewicht (kg)</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="bestelling.gewicht"
                  placeholder="Gewicht"
                  readonly
                  disabled
                />
                <label>Prijs (€)</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="bestelling.prijs"
                  placeholder="Prijs"
                  disabled
                  readonly
                />
                <label>Betalingswijze</label>
                <select
                  class="form-control"
                  v-model="bestelling.betalingswijze"
                  :selected="bestelling.betalingswijze"
                  disabled
                  readonly
                >
                  <option value="Factuur">Factuur</option>
                  <option value="Contant">Contant</option>
                  <option value="Bancontact">Bancontact</option>
                </select>
                <label>Betalingsstatus</label>
                <select class="form-control" v-model="bestelling.betalingsstatus">
                  <option value="Niet betaald">Niet betaald</option>
                  <option value="Betaald">Betaald</option>
                </select>
                <label>Opmerking</label>
                <select class="form-control" v-model="bestelling.opmerkingen">
                  <option value disabled>- Selecteer opmerking -</option>
                  <option value="Niemand aanwezig">Niemand aanwezig</option>
                  <option value="Niemand aanwezig voor betaling">
                    Niemand aanwezig voor betaling
                  </option>
                  <option value="Container boven rand geladen">
                    Container boven rand geladen
                  </option>
                  <option value="Container overladen (gewicht)">
                    Container overladen (gewicht)
                  </option>
                  <option value="Wachttijd overschreden (15min.)">
                    Wachttijd overschreden (15min.)
                  </option>
                  <option value="Container onmogelijk bereikbaar">
                    Container onmogelijk bereikbaar
                  </option>
                </select>
                <label>Notities</label>
                <textarea class="form-control" v-model="bestelling.notities" placeholder="Notities"></textarea>
                <button
                  type="button"
                  class="btn btn-secondary float-right mt-2"
                  v-on:click="printVrachtbon(bestelling.id, 'ophaling')"
                >
                  Print vrachtbon
                </button>
              </div>
              <div role="tabpanel" class="tab-pane" id="fotosTab" v-if="bestelling">
                <div class="upload-container">
                  <vue-upload-multiple-image
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                    :data-images="bestelling.fotos"
                  ></vue-upload-multiple-image>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" v-on:click="updateBestelling()">
              Aanpassen
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Sluiten
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal name="signModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Tekenen</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="signatureContainer">
              <VPerfectSignature style="position: relative" :stroke-options="strokeOptions" ref="signaturePad" />
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" v-on:click="clear()">
              Opnieuw
            </button>
            <button type="button" class="btn btn-primary" v-on:click="saveSignature()">
              Opslaan
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
// Documentation: https://antoniandre.github.io/vue-cal
import Vue from "vue";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";
import "vue-cal/dist/drag-and-drop.js";

import axios from "axios";
import moment from "moment";

import VModal from "vue-js-modal";
Vue.use(VModal, { componentName: "modal" });

import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import VPerfectSignature from "v-perfect-signature";
//import VueUploadMultipleImage from "vue-upload-multiple-image";

export default {
  components: { VueCal, VueTimepicker, VPerfectSignature },
  mounted() {
    this.getWerven();
    this.getVrachtwagens();
    this.getChauffeurs();
    this.getContainers();
    this.getLeveringsproducten();
    this.getKlanten();
  },
  methods: {
    onEventDragStart(e, draggable) {
      console.log("test");
      // Passing the event's data to Vue Cal through the DataTransfer object.
      e.dataTransfer.setData("event", JSON.stringify(draggable));
      e.dataTransfer.setData("cursor-grab-at", e.offsetY);
    },
    async loadEvents(cal) {
      const start = cal.startDate;
      const end = cal.endDate;
      const params = {
        start: start,
        end: end,
      };

      const bestellingen = await axios.get("https://hofman.weblion.be/api/bestellingen/", {
        params,
      });

      const leveringen = await axios.get("https://hofman.weblion.be/api/leveringen/", {
        params,
      });

      const events = [...leveringen.data, ...bestellingen.data];

      this.events = events.map((x) => (x.datum ? this.transformLevering(x) : this.transformBestelling(x, start, end)));
    },
    transformBestelling(x, start, end) {
      const type = moment(x.leveringsdatum).isBetween(start, end) ? "levering" : "ophaling";
      const datum = type === "levering" ? x.leveringsdatum : x.ophalingsdatum;
      const uur = type === "levering" ? x.leveringsrichtuur : x.ophalingsrichtuur;
      return {
        ...x,
        title: x.afval_info.naam,
        content: x.werf_info
          ? `${x.werf_info?.straat} ${x.werf_info?.huisnummer}, ${x.werf_info?.postcode} ${x.werf_info?.gemeente}`
          : "Geen adres",
        start: `${datum} ${uur}`,
        class: type,
        end: moment(`${datum} ${uur}`)
          .add(30, "minutes")
          .format("YYYY-MM-DD HH:mm:ss"),
      };
    },
    transformLevering(x) {
      return {
        ...x,
        title: x.leveringsproduct_info.naam,
        content: x.werf_info
          ? `${x.werf_info?.straat} ${x.werf_info?.huisnummer}, ${x.werf_info?.postcode} ${x.werf_info?.gemeente}`
          : "Geen adres",
        start: `${x.datum} ${x.richtuur}`,
        class: "levering-product",
        end: moment(`${x.datum} ${x.richtuur}`)
          .add(30, "minutes")
          .format("YYYY-MM-DD HH:mm:ss"),
      };
    },
    editEvent(event, e) {
      console.log({ event });
      this.bestelling = event;

      /* const type = event.class;
      const id = event.id; */
      this.$modal.show("overzichtModal");

      e.stopPropagation();
    },
    getContainers() {
      axios.get("https://hofman.weblion.be/api/containers/").then((response) => {
        this.containers = response.data;
      });
    },
    getVrachtwagens() {
      axios.get("https://hofman.weblion.be/api/vrachtwagens/").then((response) => {
        this.vrachtwagens = response.data;
      });
    },
    getChauffeurs() {
      axios.get("https://hofman.weblion.be/api/chauffeurs/").then((response) => {
        this.chauffeurs = response.data;
      });
    },
    getWerven() {
      axios.get("https://hofman.weblion.be/api/werven/").then((response) => {
        this.werven = response.data;
        console.log(response.data);
      });
    },
    getLeveringsproducten() {
      axios.get("https://hofman.weblion.be/api/leveringsproducten/").then((response) => {
        this.leveringsproducten = response.data;
      });
    },
    getKlanten() {
      axios.get("https://hofman.weblion.be/api/klanten/").then((response) => {
        this.klanten = response.data;
      });
    },
    uploadImageSuccess() {
      axios
        .post("https://hofman.weblion.be/api/afbeeldingen/", {
          bestelling: this.bestelling,
        })
        .then((response) => {
          console.log(response.data);
        });
    },
    beforeRemove(index, done) {
      done();

      axios
        .post("https://hofman.weblion.be/api/afbeeldingen/", {
          bestelling: this.bestelling,
        })
        .then((response) => {
          console.log(response.data);
        });
    },
  },
  data: () => ({
    utype: "Administrator",
    events: [],
    bestelling: null,
    containers: {},
    vrachtwagens: {},
    chauffeurs: {},
    werven: {},
    modalType: null,
    strokeOptions: {
      size: 4,
      thinning: 0,
      smoothing: 0.5,
      streamline: 0.5,
    },
  }),
};
</script>

<style>
html {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
